import React from "react";
import { Backdrop, CircularProgress, Typography } from "@mui/material";

type LoadingOverlayProps = {
  open: boolean;
  title?: string;
  message?: string;
};

/**
 * 処理中のローディング表示コンポーネント
 * 画面全体をオーバーレイして処理中であることを示す
 */
const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  open,
  title = "処理中...",
  message,
}) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
      open={open}
    >
      <CircularProgress color="inherit" size={60} />
      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
        {title}
      </Typography>
      {message && (
        <Typography variant="body2">
          {message}
        </Typography>
      )}
    </Backdrop>
  );
};

export default LoadingOverlay;
